import React, { useEffect, useState } from "react";
import { Container, Row, Col, Button, Modal, Form } from "react-bootstrap";
import { Link, useLocation, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  handleAssignBudget,
  handleGetAdminData,
  handleGetCompanyData,
} from "../store/actions/adminActions";
import TableComponent from "../components/TableComponent/TableComponent";
import UserComponent from "../components/UserComponent/UserComponent";
import { ICONS } from "../constants/constants";
import TitleComponent from "../components/TitleComponent/TitleComponent";
import BarChartComponent from "../components/GraphComponent/BarChartComponent";
import LineChartComponent from "../components/LineGraphComponent/LineChartComponent";
import Loader from "../assets/images/loader.gif";
const AdminUser = () => {
  const { id } = useParams(); // Get admin ID from URL params
  const location = useLocation();
  const adminId = id || location?.state?.admin?.id; // Handle fallback for admin ID
  const [errors, setErrors] = useState({});
  const [showShiriahBudgetModal, setShowShiriahBudgetModal] = useState(false);
  const handleClose = () => setShowShiriahBudgetModal(false);
  const handleShiriahModalShow = () => setShowShiriahBudgetModal(true);
  const [shiriahBudget, setShiriahBudget] = useState(0);

  // const admin = location?.state?.admin;
  const { adminList, isLoading } = useSelector((state) => state.admin);
  //const [showShiriahBudget, setShowShiriahBudget] = useState(false);
  const adminShiriahBudget =
    adminList?.shiriahBudget?.length > 0
      ? parseFloat(adminList.shiriahBudget[0]?.budgetPerAcre)
      : 0;

  const dispatch = useDispatch();

  // Fetch admin data when component mounts or adminId changes
  useEffect(() => {
    // If opened via Managers page with manager state, fetch company data for that manager
    const manager = location?.state?.manager;
    if (manager && manager.company?.id) {
      dispatch(handleGetCompanyData(manager.company.id));
    } else if (adminId) {
      dispatch(handleGetAdminData(adminId));
    }
  }, [dispatch, adminId]);



 
const validateBudgetForm = () => {
  let newErrors = {};

  // Validate shiriahBudget
  if (shiriahBudget <= 0) {
    newErrors.shiriahBudget = "Budget must be greater than zero";
  }


  setErrors(newErrors);

  // Return true if no errors, false if errors exist
  return Object.keys(newErrors).length === 0;
};




  const addBudget = async () => {
    if (!validateBudgetForm()) return;
    if (shiriahBudget > 0 && adminId) {

      // Pass the budgetPerAcre object to the API helper
      const formData = { budgetPerAcre: shiriahBudget };

      const result = await handleAssignBudget(formData, adminId, dispatch);
      if(result){
      setShowShiriahBudgetModal(false);
      }
    }
  };


  // Log admin data for debugging

  // Loading state
  if (isLoading) {
    return (
      <div className="loaderOverlay">
        <img src={Loader} alt="Loader" />
      </div>
    );
  }

  // No admin data found
  if (!adminList) {
    return <div>No Admin Data Available</div>;
  }

  // Define column structures for tables
  const farmerColumns = [
    "Farmer ID",
    "Name",
    "City",
  
    "Contact",
    "Actions",
  ];
  const supplierColumns = [
    "Supplier ID",
    "Name",
    "Company",
 
    "Contact",
    "Actions",
  ];
  const consultantColumns = [
    "Consultant ID",
    "Name",
    "Specialty",

    "Contact",
    "Actions",
  ];

  // Filter and format data for tables
  const farmers =
    adminList?.admin?.adminUsers?.filter((user) => user.role === "farmer") || [];
  const nooffarmers = adminList?.admin?.adminUsers?.filter(
    (user) => user.role === "farmer"
  ).length;
  const suppliers =
    adminList?.admin?.adminUsers?.filter((user) => user.role === "supplier") || [];
  const noofsuppliers = adminList?.admin?.adminUsers?.filter(
    (user) => user.role === "supplier"
  ).length;
  const consultants =
    adminList?.admin?.adminUsers?.filter((user) => user.role === "consultant") || [];
  const noofconsultants = adminList?.admin?.adminUsers?.filter(
    (user) => user.role === "consultant"
  ).length;
  const adminUsers = adminList?.admin?.adminUsers || []; // Safely access adminUsers

  let totalFarmArea = 0;

  adminUsers.forEach((user) => {
    const farmDetails = user?.farmDetails || []; // Safely access farmDetails
    farmDetails.forEach((farm) => {
      totalFarmArea += Number(farm?.farm_area) || 0; // Convert farm_area to a number
    });
  });


  const farmerData = farmers.map((farmer) => ({
    "Farmer ID": farmer.id,
    Name: farmer.name,
    City: farmer.city || "N/A",
    // Email: farmer.email,
    Status: farmer.account_status,
    Contact: farmer.mobile_number || "N/A",

    Actions:
      farmer?.account_status === "Approved" ? (
        <>
          <Link
            to={`/farmer/${farmer.id}`}
            state={{ farmer }} // Correct way to send state in React Router v6
            rel="noopener noreferrer"
          >
            <img src={ICONS.viewIcon} alt="View" className="tick-icon" />
          </Link>
          {/* <img src={ICONS.editIcon} alt="Edit" className="cross-icon" /> */}
          <img src={ICONS.downloadIcon} alt="Download" className="cross-icon" />
        </>
      ) : (
        <>
          <Link
            to={`/farmer/${farmer.id}`}
            state={{ farmer }} // Correct way to send state in React Router v6
            rel="noopener noreferrer"
          >
            <img src={ICONS.viewIcon} alt="View" className="tick-icon" />
          </Link>
          {/* <img src={ICONS.editIcon} alt="Edit" className="cross-icon" /> */}

          {/* <img src={ICONS.tickIcon} alt="Alert" className="tick-icon" 
          onClick={() => approveSupplier(farmer.id)}
          /> */}
          {/* <img src={ICONS.crossIcon} alt="Pending" className="pending-icon ms-4" /> */}
        </>
      ),
  }));

  const supplierData = suppliers.map((supplier) => ({
    "Supplier ID": supplier.id,
    Name: supplier.name,
    Company: supplier.company || "N/A",
    // Email: supplier.email,
    Status: supplier.account_status,
    Contact: supplier.mobile_number || "N/A",
    Actions:
      supplier?.account_status === "Approved" ? (
        <>
          <Link
            to={`/supplier/${supplier.id}`}
            state={{ supplier }} // Correct way to send state in React Router v6
            rel="noopener noreferrer"
          >
            <img src={ICONS.viewIcon} alt="View" className="tick-icon" />
          </Link>
          {/* <img src={ICONS.editIcon} alt="Edit" className="cross-icon" /> */}
          <img src={ICONS.downloadIcon} alt="Download" className="cross-icon" />
        </>
      ) : (
        <>
          <Link
            to={`/supplier/${supplier.id}`}
            state={{ supplier }} // Correct way to send state in React Router v6
            rel="noopener noreferrer"
          >
            <img src={ICONS.viewIcon} alt="View" className="tick-icon" />
          </Link>
          {/* <img src={ICONS.editIcon} alt="Edit" className="cross-icon" /> */}

          {/* <img src={ICONS.tickIcon} alt="Alert" className="tick-icon" 
          onClick={() => approveSupplier(farmer.id)}
          /> */}
          {/* <img src={ICONS.crossIcon} alt="Pending" className="pending-icon ms-4" /> */}
        </>
      ),
  }));

  const consultantData = consultants.map((consultant) => ({
    "Consultant ID": consultant.id,
    Name: consultant.name,
    Specialty: consultant.specialty || "N/A",
    // Email: consultant.email,
    Status: consultant.account_status,
    Contact: consultant.mobile_number || "N/A",
    Actions:
      consultant?.account_status === "Approved" ? (
        <>
          <Link
            to={`/consultant/${consultant.id}`}
            state={{ consultant }} // Correct way to send state in React Router v6
            rel="noopener noreferrer"
          >
            <img src={ICONS.viewIcon} alt="View" className="tick-icon" />
          </Link>
          {/* <img src={ICONS.editIcon} alt="Edit" className="cross-icon" /> */}
          <img src={ICONS.downloadIcon} alt="Download" className="cross-icon" />
        </>
      ) : (
        <>
          <Link
            to={`/consultant/${consultant.id}`}
            state={{ consultant }} // Correct way to send state in React Router v6
            rel="noopener noreferrer"
          >
            <img src={ICONS.viewIcon} alt="View" className="tick-icon" />
          </Link>
          {/* <img src={ICONS.editIcon} alt="Edit" className="cross-icon" /> */}

          {/* <img src={ICONS.tickIcon} alt="Alert" className="tick-icon" 
          onClick={() => approveSupplier(farmer.id)}
          /> */}
          {/* <img src={ICONS.crossIcon} alt="Pending" className="pending-icon ms-4" /> */}
        </>
      ),
  }));

  //   const userData = {
  //     id: admin?.id || "N/A",
  //     name: admin?.name || "N/A",
  //     role: admin?.role || "N/A",
  //     email: admin?.email || "N/A",
  //     joinedDate: admin?.created_at || "N/A",
  //     cnic: admin?.cnic || "N/A",
  //     mobile: admin?.mobile_number || "N/A",
  //     city: admin?.city || "N/A",
  //     address: admin?.address || "N/A",
  //     accountStatus: admin?.account_status || "N/A",
  //   };

  const barChartData = {
    labels: ["January", "February", "March", "April", "May", "June", "July"],
    datasets: [
      {
        label: "2024",
        data: [12, 19, 3, 5, 2, 3, 7],
        backgroundColor: "rgba(75, 192, 192, 0.6)",
      },
      {
        label: "2023",
        data: [10, 14, 5, 2, 20, 30, 45],
        backgroundColor: "rgba(255, 159, 64, 0.6)",
      },
    ],
  };

  const lineChartData = {
    labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep"],
    datasets: [
      {
        label: "Budget",
        data: [30, 45, 28, 50, 42, 56, 40, 55, 30],
        borderColor: "rgba(75, 192, 192, 1)",
        backgroundColor: "rgba(75, 192, 192, 0.2)",
        tension: 0.4,
      },
      {
        label: "Return",
        data: [20, 35, 25, 45, 35, 50, 38, 48, 25],
        borderColor: "rgba(255, 159, 64, 1)",
        backgroundColor: "rgba(255, 159, 64, 0.2)",
        tension: 0.4,
      },
      {
        label: "Earn",
        data: [25, 40, 22, 48, 38, 52, 33, 50, 28],
        borderColor: "rgba(153, 102, 255, 1)",
        backgroundColor: "rgba(153, 102, 255, 0.2)",
        tension: 0.4,
      },
    ],
  };

  //   const admin = adminList?.admin;

  const userData = {
    id: adminList?.admin?.id || "N/A",
    name: adminList?.admin?.name || "N/A",
    userdatarole: adminList?.admin?.role || "Admin", // Use "Admin" as a default since no role exists
    email: adminList?.admin?.email || "N/A",
    joinedDate: adminList?.admin?.created_at || "N/A",
    cnic: adminList?.admin?.cnic || "N/A",
    mobile: adminList?.admin?.mobile_number || "N/A",
    city: adminList?.admin?.city || "N/A",
    address: adminList?.admin?.address || "N/A",
    land: `${totalFarmArea} Acre`,
    farmers: `${nooffarmers} `,
    suppliers: `${noofsuppliers} `,
    consultants: `${noofconsultants} `,
    cnicImages:
      adminList?.admin?.images?.length > 0 ? adminList?.admin?.images : [], // Use `images` as the source
    farmDetails: {}, // No `farmDetails` in your data, so return an empty object
    account_status: adminList?.admin?.account_status || "N/A",
  };

  const userDetailsArray = [
    { label: "Cnic", value: userData.cnic },
    // { label: "City", value: userData.city },
    { label: "Address", value: userData.address },
    { label: "Land Covered", value: userData.land },
    { label: "No of Farmers", value: userData.farmers },
    { label: "No of Suppliers", value: userData.suppliers },
    { label: "No of Consultants", value: userData.consultants },
    // { label: "No of Farmers with Completed Tasks", value: userData.completedtaskfarmers },
    // { label: "No of Farmers with Pending Tasks", value: userData.pendingtaskfarmers },
    { label: " ", value: userData.empty },
  ];

  // Display admin data in tables
  return (
    <Container>
      <Row>
        <Col lg={12} className="breadcrum-container ">
          <Row className="breadcrum-container  py-3">
            <Col lg={12}>
              <div className="custom-breadcrumb">
                <img src={ICONS.farmer} className="icon" alt="Farmer Icon" />
                <span>
                  <Link to="/admins">Admins</Link>
                </span>
                <span>
                  {adminList?.admin?.name} ({adminList?.admin?.id})
                </span>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row>
        <Col lg={12} className="component-container mb-2">
          <UserComponent user={userData} userDetails={userDetailsArray} />
          <Col lg={12} className="flexisblle">
            {adminShiriahBudget <= 0 ? (
              <Button className="button" onClick={handleShiriahModalShow}>
                Add Shariah Budget
              </Button>
            ) : (
              <span className="text-center bold-text">
                Assigned Budget Per Acre ={` ${adminShiriahBudget} Rs/-`}
              </span>
              // <Button className="button">Show Shiriah Budget</Button>
            )}
          </Col>
        </Col>
      </Row>

      <Modal show={showShiriahBudgetModal} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Assign Budget</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group>
            <Form.Label>Budget Per Acre<span style={{ color: 'red' }}>*</span></Form.Label>
            <Form.Control
              type="number"
              value={shiriahBudget}
              onChange={(e) => {
                setShiriahBudget(e.target.value)
                if (errors.shiriahBudget) {
                  setErrors({
                    ...errors,
                    shiriahBudget: "", // Clear the error when user starts typing
                  });
                }
              }}
              placeholder="Enter budget per acre"
              isInvalid={!!errors.shiriahBudget} 
            />
            <Form.Control.Feedback type="invalid">
    {errors.shiriahBudget}
  </Form.Control.Feedback>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button className="button" onClick={addBudget}>
            Add Budget
          </Button>
        </Modal.Footer>
      </Modal>

      <Row className="two-columns">
        <Col className="component-container">
          <TitleComponent title="Usage" />
          <BarChartComponent data={barChartData} />
        </Col>
        <Col className="component-container right">
          <TitleComponent title="Finance" />
          <LineChartComponent data={lineChartData} />
        </Col>
      </Row>
      <Row>
        {/* Farmers Table */}
        <Col lg={12} className="component-container mb-2">
          <TableComponent
            columns={farmerColumns}
            data={farmerData}
            title="Farmers"
            showSearchBar={true}
            searchplaceholder="Search Farmers"
            showFilter={true}
            showTabs={true}
            showColors={false}
          />
        </Col>

        {/* Suppliers Table */}
        <Col lg={12} className="component-container mb-2">
          <TableComponent
            columns={supplierColumns}
            data={supplierData}
            title="Suppliers"
            showSearchBar={true}
            searchplaceholder="Search Suppliers"
            showFilter={true}
            showTabs={true}
            showColors={false}
          />
        </Col>

        {/* Consultants Table */}
        <Col lg={12} className="component-container mb-2">
          <TableComponent
            columns={consultantColumns}
            data={consultantData}
            title="Consultants"
            showSearchBar={true}
            showFilter={true}
            showTabs={true}
            showColors={false}
            showCount={false}
            onEdit={false}
            onDelete={false}
            onDownload={false}
            showAddNewAdmin={false}
            searchplaceholder="Search by Farmer’s Name, CNIC, Crop"
            customClass=""
          />
        </Col>
      </Row>
    </Container>
  );
};

export default AdminUser;
